<template>
  <ul v-for="latter in list" :key="latter.s_training_id">
    <li>
      <ListItem
        :text="latter.program"
        :href="setHref(latter)"
        :labels="setLabels(latter)"
        :isShowlabels="true"
        @click-item="showLatterDetail(latter.s_training_id)"
      />
    </li>
  </ul>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/runtime-core'
import { useRoute } from 'vue-router'
import ListItem from '@/components/elements/ListItem.vue'
import { Specialist } from '@/types/HospitalDetail'

export default defineComponent({
  components: {
    ListItem
  },

  props: {
    list: {
      type: Object as PropType<Specialist[]>,
      default: () => ({})
    },
    showLatterDetail: {
      type: Function as PropType<(s_training_id: number) => void>,
      required: true
    }
  },

  setup() {
    const route = useRoute()
    const setHref = (item: Specialist) =>
      `/search/hospital/detail/${route.params.id}?tab=latter&id=${item.s_training_id}`

    const setLabels = (item: Specialist) => {
      const res = []
      if (item.facility && item.facility !== 'その他') res.push(item.facility)
      return item.program_subjects?.length
        ? [...res, ...item.program_subjects]
        : res
    }

    return {
      setHref,
      setLabels
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;
</style>
